import { useQuery } from '@tanstack/react-query';
import { attemptGetLiveConnectionStats } from 'api/OrgApi';

export const useGetLiveConnectionStats = (payload) => {
  return useQuery({
    queryKey: ['liveConnectionStats', payload],
    queryFn: () => attemptGetLiveConnectionStats(payload),
    enabled: !!payload && !!payload.payload?.location_ids && payload.payload.location_ids.length > 0, // Only run if payload exists and has location_ids
  });
};